import { toast } from "sonner"

/*
 * The one toast for a change that took effect at once and can be put back: a plain sentence of
 * what changed, and Undo. It is neutral rather than a success, since the change is only half
 * settled until the chance to undo it has passed, and it stays twice as long as Sonner's 4s, long
 * enough to reach Undo from wherever the change was made.
 */

/** How long an Undo stays within reach. */
export const undoFor = 8000

/** Says what changed, with Undo calling `undo`: "Took sean@netlife.ai off", "Added to Exec". */
export function undoableToast(message: string, undo: () => void) {
  return toast(message, { action: { label: "Undo", onClick: undo }, duration: undoFor })
}
